import React, { memo } from "react";
//css
import styles from "./Popup.module.css";
import BtnPrimary from "../Signup/SignupButtons/BtnPrimary";
const SignupSuccessPopup = ({
  popupImage,
  popupHeroText,
  popupDescription,
  popupDescriptionLG,
  btnText,
  popBtn,
  btnClick,
}) => {
  return (
    <div
      className={`${styles.login_success_popup_wrapper} ${styles.signup_popup} flex ${styles.absCenter}`}
    >
      <div className={`${styles.popup_image} ${styles.signupImg} flex`}>
        <img src={popupImage} alt="popup image" />
      </div>

      <div className={`${styles.popup_text} ${styles.signupText} flex`}>
        {popupHeroText && <span className={styles.primary}>{popupHeroText}</span>}
        {popupDescription && <p>{popupDescription}</p>}
        {popupDescriptionLG && (
          <p className={`${styles.pDescLG}`}>{popupDescriptionLG}</p>
        )}
        {popBtn && (
          <BtnPrimary
            text={btnText}
            onClick={btnClick}
            customClassName={styles.submitBtn}
          />
        )}
      </div>
    </div>
  );
};

export default memo(SignupSuccessPopup);
